import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ApplicationRouting from './routing/ApplicationRouting';
import { Provider } from 'react-redux'
import { AccesstokenStore } from './redux/store';
import Metadata from './whatsapp/small_component/metadata';
import './index.css';
import { UserServices } from './component/login/UserServices.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={AccesstokenStore}>
        <BrowserRouter>
            <UserServices>
                <Metadata/>
                <ApplicationRouting/>
            </UserServices>
        </BrowserRouter>
    </Provider>
);
